import React from 'react';
import { FontIcon, Toggle, Popover } from 'material-ui';
import { css, StyleSheet } from 'aphrodite';
import SortableList from '../../tc-ui/sortable-list-with-react-dnd/sortable-list';
import DraggableCard from '../../tc-ui/sortable-list-with-react-dnd/draggable-card';
import Example from './rate-name-text-example';
import CheckedCircleIcon from 'material-ui/svg-icons/action/check-circle';
import { propEq, call, compose, map, keys } from 'ramda';

const border = '1px dashed rgba(0, 0, 0, 0.54)';
const disableDragBorder = '1px solid rgba(0, 0, 0, 0.54)';
const styles = StyleSheet.create({
  listContainer: { display: 'flex', width: '100%' },
  draggableCard: { margin: '0px 0px 8px 32px', width: '90%' },
  sortableItem: { border, padding: '12px 6px', display: 'flex', alignItems: 'center' },
  nonSortableItem: { border: disableDragBorder, padding: '12px 6px', display: 'flex', alignItems: 'center' },
  text: { display: 'inline-block', width: '80%', marginLeft: '6px', position: 'relative', top: '-2px', cursor: 'pointer' },
});

const plusOr = combination => (
  <div style={{ textAlign: 'center', height: '65px' }}>
    { combination ? <span style={{ top: '45px', position: 'relative' }}>AND</span> :
      <span style={{ top: '45px', position: 'relative' }}>OR</span>
    }
  </div>
);

const CheckSortList = ({
  arrayOfData,
  popoverContent,
  popoverOpen,
  anchorEl,
  closePopover,
  openPopover,
  dragEnds,
  checkAnItem,
  useCombination,
  onToggle,
  limit,
}) => {
  return (
    <div>
      <Toggle
        label="Combine"
        labelPosition="right"
        style={{ width: '30%', marginLeft: '32px', marginBottom: '16px' }}
        toggled={useCombination}
        onToggle={(_, toggeled) => onToggle(toggeled)}
      />
      <div className={css(styles.listContainer)}>
        <SortableList
          style={{ width: '45%', display: 'inline-block' }}
          arrayOfData={arrayOfData}
          dragEnds={dragEnds}
        >
          {
            arrayOfData.map((item, index) => (
              <DraggableCard key={index} className={css(styles.draggableCard)} isDragSource={item.checked} isDropTarget={item.checked}>
                <div className={css(styles[item.checked ? 'sortableItem' : 'nonSortableItem'])}>
                  <CheckedCircleIcon
                    onTouchTap={() => checkAnItem(item)}
                    style={{ cursor: 'pointer', fill: item.checked ? 'rgb(0, 188, 212)' : '#eeeeee' }}
                  />
                  <div className={css(styles.text)} onClick={({ currentTarget }) => openPopover(currentTarget, item.mappings)}>{item.text}</div>
                  <FontIcon className="tc-icon-swap_vert" style={{ color: item.checked ? 'rgba(0, 0, 0, 0.34)' : 'white', top: '5px' }}/>
                </div>
              </DraggableCard>))
          }
        </SortableList>
        <div style={{ display: 'inline-block', width: '5%' }}>
          {
            arrayOfData.filter(propEq('checked', true)).map((_, index) => index ? plusOr(useCombination) : <div/>)
          }
        </div>
        <div style={{ marginLeft: '16px', width: '45%', fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" }}>
          <div style={{ marginBottom: '16px', fontWeight: 'bold', borderBottom: '1px solid rgba(0, 0, 0, 0.34)' }}>Example:</div>
          <Example
            rule={arrayOfData}
            combinable={useCombination}
            limit={limit}
          />
        </div>
        <Popover
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          anchorEl={anchorEl}
          open={popoverOpen}
          onRequestClose={closePopover}
          style={{ padding: '16px', fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif", width: '400px' }}
        >
          {
            call(compose(
              map(key => (
                <div>
                  <div style={{ width: '55%', display: 'inline-block' }}>{key}</div>
                  <FontIcon className="tc-icon-arrow-right2" style={{ fontSize: '15px', margin: '0 5px', top: '2px' }} color={"#c8c8c8"}/>
                  <div style={{ marginLeft: '32px', display: 'inline-block' }}>{popoverContent[key]}</div>
                </div>)),
              keys
            ), popoverContent)
          }
        </Popover>
      </div>
      <div style={{ marginLeft: '32px' }}>* when applicable</div>
    </div>
  );
};

export default CheckSortList;



// WEBPACK FOOTER //
// ./src/app/components/integration/settings/rate-name-text-settings-list-DUMB.jsx